import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import style from './style.scss'; //NOSONAR

const TooltipError = (props) => {

    useEffect(() => {
        document.addEventListener('click', clickOut, false);
        document.addEventListener('touch', clickOut, false);
        return function cleanup() {
            document.removeEventListener('click', clickOut);
            document.removeEventListener('touch', clickOut);
        }
    },[]);

    const clickOut = () => {
        const callback = props.clickOut;

        if(callback) callback();
    }

    return <div className='tooltip-error'>
        <div className='tooltip-error-content'>{props.message}</div>
    </div>;
    
}

TooltipError.propTypes = {
    message: PropTypes.string,
    clickOut:  PropTypes.func
};

export default TooltipError;
